import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { UserState } from '@juvare/platform-sdk-react/types';

export const canViewLogiReports = (userState: UserState) => {
    return (
        requireAnySystemPermission(userState, 'view-reports', 'all-organizations-admin') ||
        requireAnyOrgPermission(userState, 'run-reports')
    );
};

export const canManageLogiReports = (userState: UserState) => {
    return requireAnySystemPermission(userState, 'manage-reports');
};

export const canAdministerLogiReportSources = (userState: UserState) => {
    return requireAnySystemPermission(userState, 'administer-report-sources');
};
